import { Fragment } from 'react'

import { Section, SectionList, SubTitle } from '@/components/ArticleElement'
import PoliciesLayout from '@/components/Layouts/PoliciesLayout'
import { useLanguage } from '@/hooks/Contexts'

const AcceptableUsePolicy = () => {
  const {
    acceptable_use: { acceptable_use_policy, titles, paragraphs, lists },
  } = useLanguage()

  return (
    <PoliciesLayout title={acceptable_use_policy}>
      {titles.map((title, i) => (
        <Fragment key={i}>
          {title && <SubTitle extraCls='mt-4 first:mt-0'>{title}</SubTitle>}

          {paragraphs[i] && <Section paragraphs={paragraphs[i]} paragraphCls='mt-2' />}

          {lists[i] && <SectionList listCls='list-decimal' list={lists[i]} />}
        </Fragment>
      ))}
    </PoliciesLayout>
  )
}

export default AcceptableUsePolicy
